(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-multiplier-timer]').forEach(root => {
      if (root.dataset.multiplierReady) return;
      root.dataset.multiplierReady = 'true';
      const end = Date.parse(root.dataset.endTime || '');
      const surface = root.closest('[data-multiplier-surface]');
      const fields = ['days', 'hours', 'minutes', 'seconds'].map(unit => root.querySelector(`[data-multiplier-${unit}]`));
      const daysUnit = root.querySelector('[data-multiplier-day-unit]');
      const tick = () => {
        if (!root.isConnected) return;
        const seconds = Math.floor((end - Date.now()) / 1000);
        if (!Number.isFinite(end) || seconds <= 0) {
          surface?.querySelectorAll('[data-multiplier-promo]').forEach(node => { node.hidden = true; });
          if (surface?.hasAttribute('data-multiplier-promo-only')) surface.hidden = true;
          else surface?.querySelectorAll('[data-multiplier-fallback]').forEach(node => { node.hidden = false; });
          window.dispatchEvent(new Event('resize'));
          return;
        }
        const values = [Math.floor(seconds / 86400), Math.floor(seconds % 86400 / 3600), Math.floor(seconds % 3600 / 60), seconds % 60];
        fields.forEach((field, index) => { if (field) field.textContent = String(values[index]).padStart(2, '0'); });
        if (daysUnit) daysUnit.style.display = values[0] === 0 ? 'none' : '';
        window.setTimeout(tick, 1000);
      };
      tick();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
